<template>
  <div class="agri-heade" ref="headerRef">
    <header class="header">
      <div class="header-left">
        <div class="header-logo">
          <img class="logo cursor-pointer"
          @click="toHref('/')"
          v-if="platInfo.logo"
          :src="commenUrl+platInfo.logo"
          alt="全球贸易服务平台">
        </div>

        <nav class="nav-menu" @mouseleave="hideNav" ref="navMenuRef">
          <div @mouseenter="showNav(itemIndex)" v-for="(item, itemIndex) in navItems" @click="toHref(item.outsideLink,item.outsideLinkTarget)" :key="item.id" class="nav-item"
            :class="[itemIndex === activeIndex ? `wui-color-${themeColor}` : '',headerHeight>80?'nav-item-two':'']">
            <!-- {{ item.name }} -->
            <span class="nav-text">{{ item.name }}</span>
            <span class="nav-border"
              :class="['wui-background-color-' + themeColor, itemIndex === activeIndex ? 'width-100' : '']"></span>
          </div>
        </nav>
      </div>

      <div class="header-right">
        <div class="search-container">
          <el-input v-model="searchText" class="search-input" :class="['wui-input-color-' + themeColor]" placeholder="搜索" :prefix-icon="Search" @keyup.enter="searchResult" />
        </div>

        <div class="login-register">
          <div class="language-selector">
            <custom-dropdown 
              text="国内版"
              :menu-items="[
                { label: '国内版', value: 'profile' },
                { label: '国际版', value: 'settings' }
              ]"
              :themeColor="themeColor"
              @item-click="handleMenuClick"
            />
          </div>
          <!-- <div class="login-btn" :class="[`wui-hover-color-${themeColor}`]" @click="getPlatInfo('chat','_blank')">平台客服</div> -->
          <div class="login-btn" v-if="!username" :class="[`wui-hover-color-${themeColor}`]" @click="toHref('login','_blank')">登录</div>
          <div class="register-btn" v-if="!username" :class="['wui-background-color-' + themeColor]" @click="toHref('register','_blank')">立即注册</div>
          <div v-if="username" :class="['wui-color-' + themeColor,'cursor-pointer']" @click="toHref('userCenter')">{{ username }}</div>
          <div @click="logout" v-if="username" :class="['wui-hover-color-' + themeColor,'cursor-pointer']">退出</div>
        </div>
      </div>
    </header>

    <transition name="fade">
      <main class="main-content" v-if="navMenu" :style="{ top: `${headerHeight}px` }" @mouseenter="showContent">
        <section class="services-section" @mouseleave="hideNav" ref="mainContent">
          <div class="section-header" @click="toHref(serviceData.depictLink,serviceData.depictLinkTarget)":class="[serviceData.depictLink ? `wui-hover-color-${themeColor} cursor-pointer section-header-have` : '']" v-if="serviceData.depict">
            <h2 class="section-title">{{serviceData.depict}}</h2>
            <div class="section-icon" v-if="serviceData.depictLink">
              <el-icon :size="20"><ArrowRightBold /></el-icon>
            </div>
          </div>
          <div class="section-content" v-if="serviceData.children">
            <div class="services-grid" :style="{gridTemplateColumns: `repeat(${serviceData.imageUrl ? 4 : Math.max(3, Math.min(5, serviceData.children.length))}, 1fr)`,flex: serviceData.imageUrl ? 4 : 1}">
              <div class="service-category" v-for="(category, categoryIndex) in serviceData.children" :key="category.name">
                <div v-if="category.children">
                  <h3 class="category-title" @click="toHref(category.outsideLink,category.outsideLinkTarget)" v-if="category.name" :class="[category.outsideLink ? `wui-hover-color-${themeColor} cursor-pointer text-decoration-underline-hover` : '']">
                    {{ category.name }}
                    <span v-if="category.label" class="section-icon-xbq" :class="['wui-background-light-'+themeColor,'wui-color-'+themeColor]">{{ category.label }}</span>
                    <span class="section-icon" v-if="category.outsideLink">
                      <el-icon :size="12"><ArrowRightBold /></el-icon>
                    </span>
                  </h3>
                  <div :class="[service.outsideLink?'service-item':'service-item-normal']" v-for="(service, serviceIndex) in category.children" :key="service.name"
                    @mouseenter="changeHovered(2, true, categoryIndex, serviceIndex)"  @click="toHref(service.outsideLink,service.outsideLinkTarget)"
                    @mouseleave="changeHovered(2, false, categoryIndex, serviceIndex)">
                    <div>
                      <span class="service-name" :class="[oneIndex === categoryIndex && twoIndex === serviceIndex&&service.outsideLink ? `wui-color-${themeColor}` : '']">{{ service.name }}</span>
                      <span v-if="service.label" class="section-icon-xbq" :class="['wui-background-light-'+themeColor,'wui-color-'+themeColor]">{{ service.label }}</span>
                    </div>
                    <div class="service-depict">{{ service.depict }}</div>
                  </div>
                </div>
                <div v-else :class="[category.outsideLink?'service-item':'service-item-normal']" @mouseenter="changeHovered(3, true, categoryIndex)"
                  @mouseleave="changeHovered(3, false, categoryIndex)" @click="toHref(category.outsideLink,category.outsideLinkTarget)">
                  <div>
                    <span class="service-name" :class="[oneIndex === categoryIndex&&category.outsideLink? `wui-color-${themeColor}` : '',]">{{ category.name }}</span>
                    <span v-if="category.label" class="section-icon-xbq" :class="['wui-background-light-'+themeColor,'wui-color-'+themeColor]">{{ category.label }}</span>
                  </div>
                  <div class="service-depict">{{ category.depict }}</div>
                </div>
                <!-- <div class="highlight-service" v-if="service.img">
                  <img :src="service.img" alt="">
                </div> -->
              </div>
            </div>
            <div class="section-img" v-if="serviceData.imageUrl" @click="toHref(serviceData.imageLink,serviceData.imageLinkTarget)" :class="[serviceData.imageLink ? `cursor-pointer` : '']">
              <img :src="commenUrl+serviceData.imageUrl" alt="">
            </div>
          </div>
        </section>
      </main>
    </transition>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref, onUnmounted, nextTick, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Search,ArrowRightBold } from '@element-plus/icons-vue'
import CustomDropdown from './customDropdown.vue'
const props = defineProps({
  themeColor: {
    type: String,
    default: 'blue'
  },
  platInfo: {
      type: Object,
      default: {}
  }
})
const { proxy } = getCurrentInstance();
const router = useRouter();
const route = useRoute();
const mainContent = ref(null);
const navMenuRef = ref(null)
const headerRef = ref(null)
let hoverTimerL = null;
const hideNav = (e) => {
  e.stopPropagation();
  isHovering.value = false;
  // 清除之前的延迟关闭计时器
  if (hoverTimerL) {
    clearTimeout(hoverTimerL);
    hoverTimerL = null;
  }

  // 检查是否在两者之间移动（A ↔ B）
  const isMovingBetweenComponents = 
    (mainContent.value?.contains(e.relatedTarget) && e.fromElement?.className === 'nav-menu') ||
    (navMenuRef.value?.contains(e.relatedTarget) && e.fromElement?.className === 'main-content');

  // 如果不在两者之间移动，则延迟关闭（300ms缓冲期）
  if (!isMovingBetweenComponents) {
    hoverTimerL = setTimeout(() => {
      // 最终验证：检查鼠标是否真的不在菜单区域（A/B）
      const isStillInMenu = 
        navMenuRef.value?.contains(document.activeElement) || 
        mainContent.value?.contains(document.activeElement);
      
      if (!isStillInMenu) {
        navMenu.value = false;
        activeIndex.value = -1;
      }
    }, 300); // 缓冲时间可调整（200-500ms）
  }
};
const searchText = ref('');
const activeIndex = ref(-1);
let hoverTimer = null;
const headerHeight = ref(0);
const isHovering = ref(false);
const showNav = (index) => {
  isHovering.value = true;
  headerHeight.value = headerRef.value.offsetHeight
   // 清除之前的计时器
  if (hoverTimer) {
    clearTimeout(hoverTimer);
    hoverTimer = null;
  }
  if(hoverTimerL){
    clearTimeout(hoverTimerL);
    hoverTimerL = null;
  }
  // 设置新的计时器，延迟1秒执行
  hoverTimer = setTimeout(() => {
    if (isHovering.value) { // 只有仍在悬停状态才执行
      activeIndex.value = index;
      if (!navItems.value[index].children) {
        navMenu.value = false;
        return
      }
      navMenu.value = true;
      twoIndex.value = -1;
      serviceData.value = navItems.value[index];
      hoverTimer = null;
    }
  }, 300);
};
const showContent = (e) => {
  e.stopPropagation();
  if(hoverTimerL){
    clearTimeout(hoverTimerL);
    hoverTimerL = null;
  }
}
const navMenu = ref(false);
const navItems = ref([])
const getHeaderMenu = ()=>{
  proxy.$request({
    url: 'PROTAL_N_INDUSTRYMENU_FINDTREELIST',
    data: {"portalType":proxy.getConfig().portalType}
  }).then((res)=>{
    navItems.value = res.data.result;
    nextTick(()=>{
      if(headerRef.value){
        headerHeight.value = headerRef.value.offsetHeight
      } 
    });
    
  })
  
}
const serviceData = ref();
const oneIndex = ref(-1);
const twoIndex = ref(-1);
const changeHovered = (level,isHovered,serviceIndex, categoryIndex ) => {
  // console.log(level,'22222')
  if(level==2){
    if(isHovered){
      oneIndex.value = serviceIndex;
      twoIndex.value = categoryIndex;
    }else{
      oneIndex.value = -1;
      twoIndex.value = -1;
    }
  }else if(level==3){
    if(isHovered){
      oneIndex.value = serviceIndex;
    }else{
      oneIndex.value = -1;
    }
  }
  
  
};

const handleMenuClick = (item) => {
  // 这里可以处理菜单项点击逻辑
  if(item.value=="settings"){
    toHref('http://global.nfstzx.com/','_blank')
  }
}
const username = ref(localStorage.getItem("userInfoB2B")?JSON.parse(localStorage.getItem("userInfoB2B")).user.loginName:'');
//监听localStorage.getItem("sznc_WebsiteUsername")变化
// 监听 storage 事件（其他标签页修改时触发）
const handleStorageChange = (e) => {
  if (e.key === 'userInfoB2B') {
    username.value = e.newValue?JSON.parse(e.newValue).user.loginName:'';
  }
};

// 重写 localStorage.setItem（当前标签页修改时触发）
const originalSetItem = localStorage.setItem;
localStorage.setItem = function (key, value) {
  originalSetItem.call(this, key, value);
  if (key === 'userInfoB2B') {
    username.value = value?JSON.parse(value).user.loginName:'';
  }
};
// 退出
function deleteCookie(name, path = '/', domain = "") {
    document.cookie = `${name}=; path=${path}; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
}
const logout = () => {
  proxy.$request({
    url: "SECURITY_W_LOGOUT",
    method: "post",
  }).then((res) => {
    if (res.data.code == "000") {
      localStorage.setItem("userInfoB2B", "");
      localStorage.setItem("membIdB2B", "");
      proxy.setSharedCookie("userInfoB2B", '')
      proxy.setSharedCookie("membIdB2B", '')
      deleteCookie('wbf_access_token')
      if(proxy.tool.isSafari()){
        //刷新页面
        window.location.reload()
      }
    }
  }).catch((err) => {
    console.log(err);
  });
}
// 初始化ResizeObserver
const initObserver = () => {
  if (headerRef.value) {
    let resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(headerRef.value);
  }
};

const emits = defineEmits(['heightChange']);
// 处理尺寸变化（带防抖）
let resizeTimer = null
const handleResize = (entries) => {
  for (const entry of entries) {
    if (resizeTimer !== null) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(() => {
      const height = Math.round(entry.contentRect.height);
      headerHeight.value = height;
      emits('heightChange', headerHeight.value);
      // 更新状态和记录历史
    }, 0);
  }
};
onMounted(async () => {
  getHeaderMenu();
  await nextTick();
    if(headerRef.value){
      initObserver()
    }
    window.addEventListener('storage', handleStorageChange);
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', ()=>{});
    localStorage.setItem = originalSetItem;
  });

  // 跳转
  // 判断是否为完整URL
    const isFullUrl = (url) => {
      return /^https?:\/\//i.test(url);
    };
    
    const getUrlParams = (url)=> {
      let params = {};
      // 处理URL，提取问号后的参数部分
      const urlStr = url || window.location.href;
      const queryString = urlStr.split('?')[1];
      
      if (!queryString) return params; // 没有参数则返回空对象
      
      // 分割参数（支持&和;分隔）
      const parts = queryString.split(/[&;]/g);
      
      for (const part of parts) {
        // 分割键值对（支持=和:分隔）
        const [key, value] = part.split(/[=:]/);
        if (key) {
          // 解码特殊字符（如中文、空格等）
          params[decodeURIComponent(key)] = decodeURIComponent(value || '');
        }
      }
      
      return params;
    }
    
  // 读取有效期内的用户名
  function getExpiringUsername(key) {
    const storedData = localStorage.getItem(key);
    
    if (!storedData) return null;
    
    const { value, expiry } = JSON.parse(storedData);
    const now = Date.now();
    
    // 检查是否过期
    if (now > expiry) {
      localStorage.removeItem(key); // 过期则删除
      return null;
    }
    
    return value; // 返回有效用户名
  }
    // 执行跳转
    const toHref = (url, type) => {
      if (!url) {
        return;
      }
      if (getUrlParams(url).loginType=='yunying'&&!getExpiringUsername("sznc_WebsiteUsername_yy")) {
        if (type === '_blank'||type == '1') {
          // 新标签页打开
          const href = router.resolve({
            path: '/loginYy',
            query: { toPath: btoa(url) }
          }).href;
          proxy.tool.openWindow(href);
        } else {
         router.push({
            path: '/loginYy',
            query: {
              toPath: btoa(url)
            }
          });
        }
        
        return;
      }
      if (type === '_blank'||type == '1') {
        // 新标签页打开
        proxy.tool.openWindow(url);
      } else if (isFullUrl(url)) {
        // 完整URL，使用页面跳转
        window.location.href = url;
      } else {
        // 相对路径，使用路由跳转
        router.push(url);
        navMenu.value = false;
      }
    };
    function searchResult(){
      router.push({path:'oneStopSearchNews',query:{'search':searchText.value}})
    }
    const adminID = ref('')
    const getPlatInfo = (url)=>{
      if(adminID.value){
        url+='?id='+adminID.value+'&sceneType=10&inboxType=10'
        proxy.tool.openWindow(url);
        return
      }
      proxy.$request({
        url:"B2B_N_PLAT_FINDDEFAULT",
        method: "post",
        data:{isLoginType:true}
      }).then((res)=>{
        if(res.data.code=="000"){
          let result=res.data.result;
          adminID.value = result.platUserId
          url+='?id='+adminID.value+'&sceneType=10&inboxType=10'
          proxy.tool.openWindow(url);
        }
      }).catch((err)=>{
        console.log(err)
      })
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.agri-heade {
  color: #121212;
  position: fixed;
  z-index: 888;
  width: 100%;
  min-width: 1240px;
  font-family: PingFangSC, PingFang SC;
  background-color: #fff;


  .cursor-pointer{
      cursor: pointer;
  }
  /* 头部导航样式 */
  .header {
    min-height: 75px;
    display: flex;
    justify-content: space-between;
   // box-shadow: 0 2px 4px rgba(245, 245, 245, 1);
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: #fff;
    width: 1200px;
    margin: auto;
    .header-left{
      display: flex;
      min-height: 75px;
      display: flex;
      // align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .header-logo{
        padding: 18px 0;
        margin-right: 60px;
        .logo {
          width: 297px;
          height: 38px;
        }
      }
      

      .nav-menu {
        display: flex;
        gap: 30px;

        .nav-item {
          opacity: 1;
          transition: opacity 0.3s ease;

          &:hover {
            opacity: 0.9;
          }
        }
      }

      .nav-item {
        font-size: 16px;
        font-weight: 500;
        white-space: nowrap;
        cursor: pointer;
        transition: color 0.3s;
        padding: 27px 0 23px !important;
        border-bottom: 3px solid transparent !important;
        height: 75px !important;
        box-sizing: border-box;
        position: relative;

        .nav-text {
          display: inline-block;
          transition: all 0.3s ease;
          font-size: 16px;
          font-weight: 500;
        }

        .nav-border {
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 3px;
          transform: translateX(-50%);
          /* 居中定位 */
          transition: width 0.5s ease;
        }

        &:hover {
          .nav-text {
            // opacity: 0.8;
            // transform: translateY(-2px);
          }

          .nav-border {
            width: 100%;
          }
        }

        .width-100 {
          width: 100%;
        }
      }
      .nav-item-two{
        padding: 9px 0 6px;
        height: 40px;
      }
    }
  }

  // .nav-item:hover {
  //     color: var(--primary);
  //     border-color: var(--primary);
  // }
  .header-right{
    display: flex;
    width: 640px;
    
    .search-container {
      display: flex;
      height: 75px;
      width: 254px;
      margin-right: 30px;
      align-items: center;
      .search-input {
        width: 254px;
        height: 36px;
        border-radius: 18px;
        /deep/ .el-input__prefix-inner{
          padding: 0 2px 0 10px;
        }
        /deep/ .el-input__wrapper{
          border-radius: 18px;
        }
        /deep/ input{
          padding-right: 14px;
        }
      }
    }

    .login-register {
      display: flex;
      align-items: center;
      gap: 30px;
      width: 354px;
      height: 75px;
    }

    .language-selector {
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
    }

    .login-btn {
      font-size: 16px;
      cursor: pointer;
    }

    .register-btn {
      border-radius: 23px;
      font-weight: 500;
      font-size: 16px;
      padding: 10px 15px;
      cursor: pointer;
      transition: background-color 0.3s;
    }

    .register-btn:hover {
      background-color: #c11a11;
    }
  }
  

  /* 主体内容样式 */
  .main-content {
    backdrop-filter: blur(6px);
    background: hsla(0, 0%, 100%, .5);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 75px;
    /* -webkit-transition: all .2s; */
    /* transition: all .2s; */
    z-index: 899;
    min-height: calc(100vh - 75px);
    height: auto;
    overflow-y: auto;
    .text-decoration-underline-hover:hover{
      -webkit-text-decoration: underline;
      text-decoration: underline;
    }
  }
  
  .section-icon-xbq{
    font-size: 12px;
    padding: 1px 4px;
    border-radius: 6px;
    margin-left: 6px;
  }
  .services-section {
    background-color: #fff;
    border-radius: 0 0 20px 20px;
    box-shadow: 0 2px 4px rgba(219, 219, 219, 0.5);
    padding: 30px 34px;
    margin-bottom: 40px;
    width: 1200px;
    margin: 0 auto;
    min-height: 500px;
    max-height: calc(-178px + 100vh);
    overflow-y: auto;
  }

  .section-header {
    // display: flex;
    // justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding-left: 16px;
    display: inline-block;
    color: #121212;
    // padding-bottom: 15px;
    // border-bottom: 1px solid #eee;

    .section-title {
      font-size: 24px;
      font-weight: 500;
      display: inline-block;
    }
    .section-icon{
      margin-left: 10px;
      display: inline-block;
    }
  }
  .section-header-have:hover{
    .section-title{
      text-decoration: underline;
    }
    .section-icon{
      transform: translateX(4px);
    }
  }
  .section-content{
    display: flex;
    gap: 30px;
  }
  .services-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
  }

  .section-img{
    flex: 1;
    min-width: 0;
    text-align: center;
    img{
      width: 100%;
      border-radius: 20px;
    }
  }

  .service-category {
    display: flex;
    flex-direction: column;
  }

  .category-title {
    font-size: 14px;
    font-weight: 600;
    color: #AEAEAE;
    margin-bottom: 20px;
    padding-left: 16px;
    align-items: center;
  }

  .service-item,.service-item-normal {
    padding: 10px 16px;
    box-shadow: 0 5px 15px transparent;
    border-radius: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    cursor: pointer;

    .service-name {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #191919;
      line-height: 20px;
      text-align: left;
      font-style: normal;
    }

    .service-depict {
      color: #838383;
      line-height: 20px;
      margin-top: 4px;
    }
  }
  .service-item-normal{
    cursor: auto;
  }
  .service-item:hover {
    box-shadow: 0 0 4px rgba(194, 194, 194, 0.5);
    transition: transform 0.3s, box-shadow 0.3s;

    .service-name {
      // color: #1663FF;
      text-decoration-line: underline;
    }

  }

  .highlight-service {
    background-color: #fff8f8;
    border: 1px solid #fff0f0;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
      width: 100%;
    }
  }

  .feature-icons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 20px 0;
  }

  .feature-icon {
    width: 50px;
    height: 50px;
    background-color: #f9e3e3;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }

  .feature-text {
    text-align: center;
    font-size: 16px;
    line-height: 1.5;
  }

  /* 侧边栏样式 */
  .sidebar {
    position: absolute;
    right: 160px;
    top: 40px;
    border-radius: 23px;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .sidebar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 15px 0;
    cursor: pointer;
  }

  .sidebar-icon {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .sidebar-text {
    font-size: 14px;
    color: var(--dark);
    text-align: center;
    line-height: 1.4;
  }

  .divider {
    width: 30px;
    height: 1px;
    background-color: #eee;
    margin: 10px 0;
  }
}

/* 淡入淡出效果 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
@media (min-width: 1680px) {
  .agri-heade{
    .header{
      width: 1600px;
    }
    .services-section{
      width: 1600px;
    }
  }
  
}
</style>
